
























































































































import Vue from 'vue';
import { mapState } from 'vuex';
import CryptoJS from 'crypto-js';
import userService from '@/services/hub/user';
import {
  HubHeading,
  HubInput,
} from '@/components/HubComponents';
import {
  BaseCard,
} from '@/components/BaseComponents';
import Helpers from '@/utils/Helpers';

export default Vue.extend({
  name: 'Customize',

  components: {
    HubHeading,
    HubInput,
    BaseCard,
  },

  props: {
    categoryId: {
      type: String,
      required: true,
    },
    hotsiteId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {

      typePlan: '',

      currentPage: 1,

      editLayoutModalIsOpen: false,

      numberOfHotsitesPerPage: 5,
      numberOfPagesAvailable: 0,
      numberVideosHomepage: '0',

      orderType: 'DESC' as 'ASC' | 'DESC',

      saveButtonLoading: false,
      linkToHotsitePage: '',

      selectedPrimaryColor: '',
      selectedSecondaryColor: '',

      videos: [] as any,
      timeOutId: 0 as unknown as NodeJS.Timeout,

      filteredPlans: [] as unknown as number | string,
      dataFiltered: [] as unknown as number | string,
      plans: [] as unknown as number | string,
      customerId: [] as unknown as number | string,
      idPlan: '' as number | string,
      categoryItems: [],

      aboutValue: '',
      facebookValue: '',
      instagramValue: '',
      twitterValue: '',
      youtubeValue: '',
      hotsiteMediaSocialId: '' as number | string,
      plan: '',
      secret: '',
      hash: '' as number | string,
      urlPlayer: '',
    };
  },

  computed: {
    ...mapState(['user']),
    userState(): Store.User.State {
      return this.user;
    },
  },

  watch: {
    search(): void {
      this.currentPage = 1;

      clearTimeout(this.timeOutId);
    },
  },

  mounted() {
    this.fetchCustomerPlan(this.categoryId);
    this.getLinkToHotsitePage(this.hotsiteId);
    const appTopBar = document.querySelector('.hub-header-back-btn') as HTMLElement;

    if (appTopBar) {
      appTopBar.style.marginLeft = '-200px';
    }

    const appTextarea = document.querySelector('textarea') as HTMLElement;

    if (appTextarea) {
      appTextarea.style.color = '#46467E';
      appTextarea.style.fontWeight = '500';
    }
  },

  methods: {
    formatDate(date: string) {
      return Helpers.formatDate((this.userState.settings.lang as Store.User.Language), date);
    },
    onPageChange(newPage: any) {
      this.currentPage = newPage;
    },
    async getCustomerPlan(id: string | number) {
      const response = await userService.getCustomerPlan(id);
      this.secret = response.data.data.secret;
      this.plan = response.data.data.name;
      this.customerId = response.data.data.id_customers;
    },
    showNotification(text: string, type: 'error' | 'success'): void {
      this.$store.dispatch('notification/create', { text, type });
    },
    async fetchCustomerPlan(id: string | number) {
      try {
        const response = await userService.getCustomerPlanId(id);
        this.idPlan = await response.data.data.selected_plan_id;
        await this.getCustomerPlan(this.idPlan);
        await this.fetchHotsiteMediaSocial(this.idPlan);
      } catch (error) {
        console.error('Error fetching hotsiteMediaSocial:', error);
      }
    },
    async fetchHotsiteMediaSocial(id: string | number) {
      try {
        const response = await userService.getHotsiteMediaSocial(id);
        this.aboutValue = response.data.about;
        this.facebookValue = response.data.facebook;
        this.instagramValue = response.data.instagram;
        this.twitterValue = response.data.twitter;
        this.youtubeValue = response.data.youtube;
        this.hotsiteMediaSocialId = id;
      } catch (error) {
        console.error('Error fetching hotsiteMediaSocial:', error);
      }
    },
    async submitForm() {
      this.getLinkToHotsitePage(this.hotsiteId);
      const hotsiteMediaSocialData = {
        id_customer_plans: this.idPlan,
        about: this.aboutValue,
        facebook: this.facebookValue,
        instagram: this.instagramValue,
        twitter: this.twitterValue,
        youtube: this.youtubeValue,
      };

      if (this.hotsiteMediaSocialId) {
        try {
          await userService.updateHotsiteMediaSocial(
            this.hotsiteMediaSocialId,
            hotsiteMediaSocialData,
          );
          this.showNotification('success_in_updating', 'success');
        } catch (error) {
          this.showNotification('error_in_updating', 'error');
          console.error('error_in_save:', error);
        }
      } else {
        try {
          await userService.createHotsiteMediaSocial(hotsiteMediaSocialData);
          this.showNotification('success_in_save', 'success');
        } catch (error) {
          this.showNotification('error_in_save', 'error');
          console.error('error_in_save:', error);
        }
      }
    },
    getLinkToHotsitePage(hotsiteId: number | string): string {
      const encryptedHotsiteId = CryptoJS.AES.encrypt(
        String(hotsiteId),
        String(process.env.VUE_APP_HOTSITE_SECRET),
      ).toString();

      this.urlPlayer = `${process.env.VUE_APP_HOTSITE}/${encodeURIComponent(encryptedHotsiteId)}/channel`;
      return `${process.env.VUE_APP_HOTSITE}/${encodeURIComponent(encryptedHotsiteId)}/channel`;
    },
    redirectToHotsitePage() {
      window.open(`${this.urlPlayer}`, '_blank');
    },
  },
});
